import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouteFormComponent } from './route-form.component';
import { SharedModule } from 'app/shared/shared.module';
import { EditableModule } from '@ngneat/edit-in-place';
import { ContactInfoFormModule } from '../contact-info/contact-info.module';
import { JobReorderModule } from '../job-reorder/job-reorder.module';
import { DataPickerModule } from '../data-picker/data-picker.module';




@NgModule({
  declarations: [
    RouteFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ContactInfoFormModule,
    EditableModule,
    JobReorderModule,
    DataPickerModule
  ],
  exports: [
    RouteFormComponent
  ]
})
export class RouteFormModule { }
